import { ERROR, LOADING, LOADED } from 'data/actions/profile';

const INITIAL_STATE = {
    content: {
        body:
            '### Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam quis dignissim augue, at hendrerit nisi. Sed tristique blandit suscipit. Sed purus urna, ornare eu mauris vel, hendrerit scelerisque arcu.\n\nIn arcu erat, rhoncus sed varius non, dignissim quis eros. Vestibulum sed porttitor elit. Sed commodo, ligula mattis dapibus molestie, tellus nibh tincidunt nisi, ac tempus eros ipsum ut lectus. Nulla sodales suscipit nisl eget luctus.',
        image: {
            fields: {
                title: 'Frozen Kurt',
                description: 'Kurt with his eyelid frozen shut',
                file: {
                    url:
                        '//images.contentful.com/kui374n3zzkx/2MDcPNj3A46MEg0USMIaEU/e10d48515ce48ad97b188d96a772cf89/4a37de81a905f95fe86186e6e9e2a2c955c057be.png'
                }
            }
        },
        phoneNumber: '+44 (0)1234 567 891',
        emailAddress: 'email@address.com',
        kitlist:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam quis dignissim augue, at hendrerit nisi. Sed tristique blandit suscipit.'
    },
    isLoading: false,
    hasLoaded: false,
    hasError: false
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case ERROR:
            return { ...state, hasError: action.error };
        case LOADING:
            return { ...state, isLoading: action.isLoading };
        case LOADED:
            return { ...state, content: action.payload, hasLoaded: true };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/data/reducers/profile.js